<template>
  <div class="main">
    <!-- banner -->
    <div class="ban" style="background-image: url('/images/ba0c1eb35598ad0d34d9ae0c732651fa.jpg');"></div>
    <!-- banner-end -->
    <!-- 内容 -->
    <div class="wp">
      <div class="g-top">
        <div class="tab">
          <ul>
            <li :class="{ on: activeTab === 'company' }">
              <a href="javascript:void(0)" @click="setActiveTab('company')">公司简介</a>
            </li>
            <li :class="{ on: activeTab === 'honors' }">
              <a href="javascript:void(0)" @click="setActiveTab('honors')">公司荣誉</a>
            </li>
            <!-- <li :class="{ on: activeTab === 'jobs' }">
              <a href="javascript:void(0)" @click="setActiveTab('jobs')">人才招聘</a>
            </li> -->
          </ul>
        </div>
        <div class="cur">
          当前位置：
          <a href="/">首页</a>
          <a href="javascript:void(0)">关于我们</a> &gt;
          <span v-if="activeTab === 'company'">公司简介</span>
          <span v-if="activeTab === 'honors'">公司荣誉</span>
          <!-- <span v-if="activeTab === 'jobs'">人才招聘</span> -->
        </div>
      </div>
    </div>
    <div v-show="activeTab === 'company'" class="row-c1">
      <div class="wp">
        <div class="m-txt1">
          <!-- 公司简介 -->
          <div class="about-content">
            <div class="txt wow fadeInLeft" data-wow-duration="1.5s" data-wow-delay="0.2s">
              <h3 class="tit">北京西宝电子技术有限责任公司</h3>
              <div class="desc" >
                <p>北京西宝电子技术有限责任公司是从事微波毫米波产品研发和生产的高科技公司，地处北京中关村高科技开发区，设有微波研发部、微波制造部，拥有完善的生产能力和装调设施。</p>
                <!-- <p>&nbsp;</p> -->
                <p>
                  西宝公司的微波产品种类多，覆盖面广，涉及50MHz—300GHz各个频段。包括各种规格的微波器件和天线，有超强的系统配套和组合能力，能为客户提供整体方案。其中毫米波领域具有特别的技术优势，可根据客户需求研发、设计和生产各类产品。
                </p>
                 <!-- <p>&nbsp;</p> -->
                <p>公司于2003年通过了ISO9001质量体系认证，确保公司产品质量管理体系的持续和改进。</p>
              <p>西宝公司愿以精湛的设计、优异的加工、出色的产品、定制的服务使您在微波集成或应用领域展翅高飞、创造未来。</p>
              </div>
            </div>
            <div class="pic wow fadeInRight" data-wow-duration="1.5s" data-wow-delay="0.25s">
              <img src="/images/p35.jpg" alt="公司简介">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="activeTab === 'company'" class="row-c2">
      <div class="wp">
        <div class="m-txt2">
          <div class="txt wow fadeInLeft" data-wow-duration="1.5s" data-wow-delay="0.2s">
            <h3 class="tit">研发 · 沉淀 · 应用</h3>
            <div class="desc">
              <p>西宝公司经历了近三十年的发展过程，是研发、设计、生产和销售为一体的实体企业。公司与各大院校合作，成功完成了众多的科研配套任务，产品被广泛应用于通信、导航、气象和医疗等微波应用领域，得到业界的好评。</p>
            </div>
          </div>
          <div class="pic wow fadeInRight" data-wow-duration="1.5s" data-wow-delay="0.25s">
            <img src="/images/p36.png" alt="研发沉淀应用">
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-show="activeTab === 'company'" class="row-c3">
      <div class="wp">
        <div class="m-txt3">
          <div class="txt wow fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.25s">
            <div class="desc">
              <p>公司于2003年通过了ISO9001质量体系认证，确保公司产品质量管理体系的持续和改进。</p>
              <p>西宝公司愿以精湛的设计、优异的加工、出色的产品、定制的服务使您在微波集成或应用领域展翅高飞、创造未来。</p>
            </div>
          </div>
          <div class="pic wow fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.2s">
            <img src="/images/p37.jpg" alt="公司理念">
          </div>
        </div>
      </div>
    </div> -->

    <!-- 公司荣誉 -->
    <div v-show="activeTab === 'honors'" class="row-b1">
      <div class="wp">
        <div class="col-l">
          <div class="m-t1">
            <span>Honor</span>
            <h3>公司荣誉</h3>
          </div>
          <div class="m-slider5">
            <div class="slider">
              <div class="item">
                <div class="desc">
                  公司通过了ISO9001质量体系认证，确保公司产品质量管理体系的持续和改进。<br> 西宝公司愿以精湛的设计、优异的加工、出色的产品、定制的服务使您在微波集成或应用领域展翅高飞、创造未来。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-r cccc is-pc">
          <el-carousel :interval="4000" type="card" height="220px" arrow="always">
            <el-carousel-item v-for="(item,index) in images" :key="index">
  
              <el-image style="width: 100%; height: 100%;" :src="item.carouselImg"
                :preview-src-list="images.map(item => item.carouselImg)">
              </el-image>
            </el-carousel-item>
          </el-carousel>
    
        </div>

        <div class="is-mobile">
                <el-carousel :interval="4000" height="220px" arrow="always">
            <el-carousel-item v-for="(item,index) in images" :key="index">
  
              <el-image style="width: 100%; height: 100%;" :src="item.carouselImg"
                :preview-src-list="images.map(item => item.carouselImg)">
              </el-image>
            </el-carousel-item>
          </el-carousel>

        </div>
      </div>
    </div>

    <!-- 人才招聘 -->
    <div v-show="activeTab === 'jobs'" class="g-bgc1">
      <div class="wp">
        <ul class="m-list5">
          <li>
            <div class="con">
              <div class="top">
                <h3 class="tit">高级射频工程师</h3>
                <div class="info">
                  <span class="s1">本科及以上</span>
                  <span class="s2">3年以上</span>
                  <span class="s3">北京</span>
                </div>
              </div>
              <div class="txt">
                <h4 class="t1">任职资格 :</h4>
                <div class="desc">
                  <p>1. 电子工程、通信工程等相关专业本科及以上学历；</p>
                  <p>2. 3年以上射频电路设计经验，熟悉微波器件原理；</p>
                  <p>3. 熟练掌握ADS、HFSS等仿真软件；</p>
                  <p>4. 具备良好的团队合作精神和沟通能力。</p>
                </div>
              </div>
              <div class="bot">投递邮箱：hr@beijingxibao.com</div>
            </div>
          </li>
          <li>
            <div class="con">
              <div class="top">
                <h3 class="tit">天线设计工程师</h3>
                <div class="info">
                  <span class="s1">硕士及以上</span>
                  <span class="s2">2年以上</span>
                  <span class="s3">北京</span>
                </div>
              </div>
              <div class="txt">
                <h4 class="t1">任职资格 :</h4>
                <div class="desc">
                  <p>1. 电磁场与微波技术、通信工程等相关专业硕士及以上学历；</p>
                  <p>2. 2年以上天线设计经验，熟悉各类天线原理与设计；</p>
                  <p>3. 熟练使用CST、HFSS等电磁仿真软件；</p>
                  <p>4. 具有较强的分析问题和解决问题的能力。</p>
                </div>
              </div>
              <div class="bot">投递邮箱：hr@beijingxibao.com</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import RequestUtil from '../utils/request';
export default {
  name: 'About',
  data() {
    return {
      images: [],
      activeTab: 'company' // 默认显示公司简介
    }
  },
  mounted() {

    // 初始化WOW动画
    this.initWowAnimation();
    this.updateActiveTabFromRoute(this.$route);



    this.$watch(
      () => this.$route,
      (to, from) => {
        this.updateActiveTabFromRoute(to);
      }
    );
    this.getImages();
  },
  methods: {
    getImages() {

      RequestUtil.get('/wx/carousel/listById?type=1').then(response => {
        this.images = response.data;
        console.log(this.images);
      });
    },

    updateActiveTabFromRoute(route) {
      const hash = route.hash; // 或者使用 route.fullPath
      // alert(hash)
      if (hash === '#honors') {
        this.activeTab = 'honors';
      } else if (hash === '#jobs') {
        this.activeTab = 'jobs';
      } else {
        this.activeTab = 'company';
      }
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    initWowAnimation() {
      // 检查WOW.js是否已加载
      if (window.WOW) {
        const wow = new window.WOW({
          boxClass: 'wow',
          animateClass: 'animated',
          offset: 0,
          mobile: true,
          live: true
        });
        wow.init();
      } else {
        // 如果WOW.js未加载，尝试动态加载
        console.warn('WOW.js is not loaded. Animations may not work.');
      }
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 1199px) {
  .is-pc {
    display: block;
  }
  .is-mobile {
    display: none;
  }
  .cccc {
    /* margin-top: 100px; */
    /* margin-top: 20vw; */
    /* display: flex;
   align-items: center;
   justify-content: center; */

    padding: 14vw 0vw 0 4vw;
    /* 调整左右 padding 大小 */

  }
}

@media only screen and (max-width: 1199px) {
  .is-pc {
    display: none;
  }
  .is-mobile {
    display: block;
  }
  .ban,
  .g-top {
    display: block !important;

  }

  .g-top {
    margin-top: -5vw;
    box-shadow: 0px 2px 21px 0px rgba(0, 24, 52, 0.07);
    background: #FFFFFF;
    height: 44px;
    line-height: 44px;


  }

  .g-top .tab li a {
    font-size: 12px !important;
  }
}
</style>